export enum EnumTipoLista {
    None = 0, // Não é uma lista
    Cadastro = 1, // Lista carregada a partir de um Cadastro
    Colaborador = 2, // Lista carregada a partir dos Colaboradores
    Personalizada = 3, // Lista com itens personalizados cadastrados no Studio
    Cascata = 4, // Lista carregada com filtro mediante valor de outro componente
    Webservice = 5 // Lista carregada com filtro mediante acesso a um webservice externo cuja url é definida no valor default
}
